import { DateTime } from 'luxon';

import { IToken } from '../models/token';
import { ITokenResponse } from '../models/token-response';
import { IUserClaims } from '../models/user-claims';

export function tokenResponseToToken(tokenResponse: ITokenResponse): IToken {
  return {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    access_token: tokenResponse.AuthToken
  };
}

export function tokenResponseToUserClaims(tokenResponse: ITokenResponse): IUserClaims {
  return {
    authMethod: tokenResponse.AuthMethod,
    expiry: typeof tokenResponse.Expiry === 'string'
      ? DateTime.fromISO(tokenResponse.Expiry)
      : tokenResponse.Expiry,
    isTransient: tokenResponse.IsTransient,
    localeId: tokenResponse.LocaleId,
    roles: tokenResponse.Roles,
    userId: tokenResponse.UserId,
    userName: tokenResponse.Username
  };
}
